import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { TickerCommandDTO, TickerConfigDTO } from '../../../../../../system/system-dtos';
import { SignInService } from '../../../../../../common/services/sign-in/sign-in.service';
import { BlastV2Service } from '../../../service/blast-v2.service';
import { ActionModalComponent } from '../../../../../action/action-modal/action-modal.component';
import { LockService } from '../../../service/lock-service';

@Component({
  selector: 'app-main-table-content-v2-row-actions',
  templateUrl: './main-table-content-v2-row-actions.component.html',
  styleUrls: ['./main-table-content-v2-row-actions.component.scss'],
  standalone: false,
})
export class MainTableContentV2RowActionsComponent {
  @Input() public tableConfig: TickerConfigDTO;

  @Input() public data: any;

  expanded: boolean;

  constructor(
    private signInService: SignInService,
    public blastV2Service: BlastV2Service,
    public lockService: LockService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  extractActions(): TickerCommandDTO[] {
    this.removeResolveFromActions();
    if (!this.lockService.isEntryLocked(this.data)) {
      return this.tableConfig.commands.filter((c) => c.command === 'lock');
    }
    if (this.lockService.isEntryLockedByCurrentAdmin(this.data)) {
      return this.tableConfig.commands.filter((command) => {
        const data = this.data;
        return command.jsEditCondition ? eval(command.jsEditCondition) : true;
      });
    }
    return this.tableConfig.commands.filter((c) => c.command === 'unlock');
  }

  removeResolveFromActions(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('withdraw')) {
      this.tableConfig.commands = this.tableConfig.commands.filter((item) => item.command !== 'withdrawticker.resolve');
    }
  }

  lockTicker() {
    this.lockService.lockTicker(this.getCollectionName(), this.data.id);
  }

  private getCollectionName() {
    return `${this.tableConfig.code}ticker`;
  }

  sendCommand(tag: string): void {
    this.executeCommand(this.data, this.data.id, tag);
  }

  public executeCommand(element: any, id: number, command: string) {
    const commandDef: TickerCommandDTO = this.tableConfig.commands.find((c) => c.command === command);
    if (commandDef.confirmationRequired || (commandDef.rows && commandDef.rows.length > 0)) {
      this.executeCommandWithModal(element, id, command);
    } else {
      this.executeSimpleCommandWithNoModal(element, id, command);
    }
  }

  public executeCommandWithModal(element: any, id: number, command: string) {
    const commandDef: TickerCommandDTO = this.tableConfig.commands.find((c) => c.command === command);

    const dialogRef = this.dialog.open(ActionModalComponent, {
      minWidth: commandDef.minModalWidth ? commandDef.minModalWidth : undefined,
      data: {
        config: commandDef,
        entity: this.data,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(filter((d) => !!d))
      .subscribe((data: any) => {
        this.doExecuteCommand(command, id, Object.keys(data).length > 0 ? data : element);
      });
  }

  public executeSimpleCommandWithNoModal(element: any, id: number, command: string) {
    this.doExecuteCommand(command, id, element);
  }

  private doExecuteCommand(command: string, id: number, element: any) {
    this.blastV2Service.sendMessage({
      cmd: command,
      data: element,
      tickerId: id,
      collection: this.getCollectionName(),
    });
  }
}
